import { IconButton, useDeviceType } from '@cian/ui-kit';
import {
  IconToggleStarOff16,
  IconToggleStarOff24,
  IconToggleStarOn16,
  IconToggleStarOn24,
} from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { trackHeaderButtonMarkAsStarredClick, trackHeaderButtonUnmarkAsStarredClick } from './tracking';
import { unmarkChatAsStarred, markChatAsStarred } from '../../actions/chatOperations';
import { currentChatOpponentIdSelector, currentOpenChatSelector, hostTypeSelector } from '../../selectors';
import { EAvailableActions } from '../../types/availableActions';
import { EDeviceType } from '../../types/deviceType';
import { EHostType } from '../../types/hostType';
import { useApplicationContext } from '../../utils/applicationContext';
import { isStarredFlagEnabled } from '../../utils/isStarredFlagEnabled';

export const ChatHeaderMarkStarredContainer = () => {
  const { config } = useApplicationContext();
  const currentChat = useSelector(currentOpenChatSelector);
  const opponentId = useSelector(currentChatOpponentIdSelector);

  const device = useDeviceType();
  const isMobile = device !== EDeviceType.Desktop;
  const hostType = useSelector(hostTypeSelector);
  const isIframe = hostType === EHostType.Frame;

  const { availableActions, offer, chatId, isStarred } = currentChat || {};

  const dispatch = useDispatch();

  // Проверка доступности кнопки "Пометить/Снять пометку важное"
  const isStarredEnabled = isStarredFlagEnabled(config);
  const isMarkAsStarredAvailable = availableActions?.includes(EAvailableActions.MarkAsStarred);
  const isUnmarkAsStarredAvailable = availableActions?.includes(EAvailableActions.UnmarkAsStarred);

  const handleButtonClick = React.useCallback(() => {
    if (!chatId) {
      return;
    }
    if (isStarred) {
      dispatch(unmarkChatAsStarred({ chatId }));
      trackHeaderButtonUnmarkAsStarredClick(offer, opponentId);

      return;
    }

    dispatch(markChatAsStarred({ chatId }));
    trackHeaderButtonMarkAsStarredClick(offer, opponentId);
  }, [chatId, isStarred, dispatch, offer, opponentId]);

  if (!isStarredEnabled && (!isMarkAsStarredAvailable || !isUnmarkAsStarredAvailable)) {
    return null;
  }

  if (isMobile || isIframe) {
    return isStarred && isUnmarkAsStarredAvailable ? (
      <IconButton onClick={handleButtonClick} icon={<IconToggleStarOn24 color="icon-main-default" />} />
    ) : !isStarred && isMarkAsStarredAvailable ? (
      <IconButton onClick={handleButtonClick} icon={<IconToggleStarOff24 color="icon-main-default" />} />
    ) : null;
  } else {
    return isStarred && isUnmarkAsStarredAvailable ? (
      <IconButton onClick={handleButtonClick} icon={<IconToggleStarOn16 />} />
    ) : !isStarred && isMarkAsStarredAvailable ? (
      <IconButton onClick={handleButtonClick} icon={<IconToggleStarOff16 />} />
    ) : null;
  }
};
